import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from '../../../../components/widgets/Select';
import selectCss from '../../../../components/widgets/ReactSelectOverrides.css';
import { findOption } from '../../utils';
import css from './style.css';

const OperatorSelect = ({ operator, operators = [], disabled = false, translate, editCondition }) => {
    const options = useMemo(() => operators.map(op => ({ value: op.value, label: translate(op.labelKey) })), [
        operators,
        translate,
    ]);

    return (
        <Select
            className={classNames(selectCss.singularSelect, css.conditionSelect)}
            classNamePrefix="Select"
            isDisabled={disabled}
            isSearchable
            isClearable={false}
            usePortal
            value={findOption(options, operator)}
            options={options}
            onChange={option => option && editCondition('operator', option.value)}
        />
    );
};

OperatorSelect.propTypes = {
    operator: PropTypes.string,
    operators: PropTypes.arrayOf(
        PropTypes.shape({ value: PropTypes.string.isRequired, labelKey: PropTypes.string.isRequired })
    ),
    disabled: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    editCondition: PropTypes.func.isRequired,
};

export default OperatorSelect;
